export default __webpack_public_path__ + "static/media/forward-arrow.92c77d20.svg";